import React from 'react'

const HomeAdmin = () => {
  return <p>HomeAdmin</p>
}

export default HomeAdmin
